<template>
  <div :class="{'one-tab': tabs.length == 1}" class="ds-control mobile dsf_teas_learning">
    <van-tabs v-model="active">
      <van-tab v-for="it in tabs" :key="it.code" :title="it.name" :name="it.code">
        <learning-special v-if="it.code == 'academicProjectClass'" :childform="form1" ref="as-academicProjectClass"></learning-special>
        <learning-course v-else-if="it.code == 'inTheCourse'" :childform="form2" ref="as-inTheCourse"></learning-course>
        <div v-else class="scroll-box">
          <dsf-mobile-teas-schedule-list :url="urlOfflineShift" :is-design="isDesign" />
        </div>
      </van-tab>
    </van-tabs>
    <div v-if="active == 'academicProjectClass'" class="choosebox">
      <div class="itembar itembar1" @click="show1 = true">
        <span>状态:</span><b>{{ parms1.choose1 }}</b
        ><dsf-icon name="xia1" />
      </div>
      <van-action-sheet
        v-model="show1"
        :actions="actions1"
        @select="onSelect1"
      />
      <div class="itembar itembar2" @click="show2 = true">
        <span>要求:</span><b>{{ parms1.choose2 }}</b
        ><dsf-icon name="xia1" />
      </div>
      <van-action-sheet
        v-model="show2"
        :actions="actions2"
        @select="onSelect2"
      />
      <div class="itembar itembar3" @click="onScreen1('xxsj1')">
        <span>学习时间</span
        ><i class="timesel" :class="{ timeselact: istime1 == true }"></i>
      </div>
    </div>
    <div v-else-if="active == 'inTheCourse'" class="choosebox">
      <div class="itembar itembar1" @click="show1 = true">
        <span>状态:</span><b>{{ parms2.choose1 }}</b
        ><dsf-icon name="xia1" />
      </div>
      <van-action-sheet
        v-model="show1"
        :actions="actions1"
        @select="onSelect1"
      />
      <div class="itembar itembar2" @click="show2 = true">
        <span>要求:</span><b>{{ parms2.choose2 }}</b
        ><dsf-icon name="xia1" />
      </div>
      <van-action-sheet
        v-model="show2"
        :actions="actions2"
        @select="onSelect2"
      />
      <div class="itembar itembar3" @click="onScreen2('xxsj2')">
        <span>学习时间</span
        ><i class="timesel" :class="{ timeselact: istime2 == true }"></i>
      </div>
    </div>
    <div v-else class="date">
      <div @click="reduce" class="icon-b"><van-icon name="arrow-left" /></div>
      <div class="title">{{ weekName }}</div>
      <div @click="add" class="icon-b"><van-icon name="arrow" /></div>
    </div>
  </div>
</template>

<script>
import learningCourse from './learningCourse';
import learningSpecial from './learningSpecial'

export default dsf.component({
  name: "DsfMobileTeasLearning",
  ctrlCaption: "在学",
  mixins: [$mixins.control],
  design: {
    isMask: false
  },
  props: {
    // 接口地址
    sourcesUrl: {
      type: String,
      default: "teasnc/course/getCourseTab",
    },
    OfflineShift: {
      type: String,
      default: 'teas/schedule/course/possiblecourses/getStuCourseByTime',
    },
  },
  data() {
    return {
      active: '',
      dayWeek: [],
      urlOfflineShift: '',
      weekNum: 0,
      tabs: [],
      form1: {
        pageSize: 10,
        namespace: "nc.ztb",
        pageName: "mhzxlist",
        //      query: '{ "searchValue":"", "sfwc":[], "sfbx":[] }',
        query: '{ "searchValue":""}',
        order: JSON.stringify([
          {
            code: "xxsj",
            sort: "asc",
          },
        ]),
      },
      form2: {
        pageSize: 10,
        namespace: "nc.kck.zxkc",
        pageName: "zxkclb",
        //      query: '{ "searchValue":"", "sfwc":[], "sfbx":[] }',
        query: '{ "searchValue":""}',
        order: JSON.stringify([
          {
            code: "xxsj",
            sort: "desc",
          },
        ]),
      },
      isfirst: true,
      show1: false,
      show2: false,
      istime1: false,
      istime2: true,
      parms1: {
        choose1: "全部",
        choose2: "全部",
      },
      parms2: {
        choose1: "全部",
        choose2: "全部",
      },
      actions1: [
        { name: "全部", value: "" },
        { name: "已通过", value: "1" },
        { name: "未通过", value: "0" },
      ],
      actions2: [
        { name: "全部", value: "" },
        { name: "必修", value: "1" },
        { name: "选修", value: "0" },
      ],
    };
  },
  components: {
    learningCourse,
    learningSpecial
  },
  provide () {
    return {
      design: this.isDesign
    }
  },

  computed: {
    weekRange() {
      if (!this.dayWeek.length) {
        return [null, null];
      }
      return [
        dsf.date.format(this.dayWeek[0], 'yyyy-mm-dd'),
        dsf.date.format(this.dayWeek[this.dayWeek.length-1], 'yyyy-mm-dd'),
      ]
    },
    weekName() {
      if (this.dayWeek.length == 0) {
        return ''
      }
      return `${dsf.date.format(new Date(this.dayWeek[0]), 'm月d日')} - ${dsf.date.format(new Date(this.dayWeek[this.dayWeek.length-1]), 'm月d日')}`
    }
  },

  watch: {
    'weekName'() {
      this.updateUrl()
    },
    'active' (val) {
      val == 'OfflineShift' && this.updateUrl()
    },
    'OfflineShift' () {
      this.updateUrl();
    },
  },

  mounted() {
    if (this.isDesign) {
      this.$dispatch("design-height-change", '100%');
    }
  },

  created() {
    if (!this.isDesign) {
      this.getTabData();
    } else {
      this.tabs = [
        {name: "在学专题班", code: "academicProjectClass"},
        {name: "在学课程", code: "inTheCourse"},
        {name: "线下班次", code: "OfflineShift"}]
    }
    this.active = 'academicProjectClass';
    this.dayWeek = this.getWeekTime();
    this.updateUrl();
  },

  methods: {
    updateUrl() {
      let url = this.OfflineShift;
      if (url && url != '') {
        url += '?isnum=false&stime=' + this.weekRange[0] + '&etime=' + this.weekRange[1];
        this.urlOfflineShift = url
      } else {
        this.urlOfflineShift = null
      }
    },
    getWeekTime(day = new Date()) {
      let w = (day.getDay() || 7) - 1;
      let arr = [];
      //星期一开始
      for (var i = 0; i < 7; i++) {
        let d = new Date(day.getTime());
        d.setDate(d.getDate() + i - w);
        arr.push(dsf.date.format(d, 'yyyy/mm/dd'));
      }
      return arr;

    },
    add() {
      this.weekNum++;
      this.dayWeek = this.getWeekTime(new Date());
    },
    reduce() {
      this.weekNum--;
      this.dayWeek = this.getWeekTime(new Date());
    },
    reset() {
      const ctrl = this.$refs["as-" + this.active];
      ctrl && ctrl[0] && ctrl[0].reset();
    },
    onChange() {
      if (this.active == 'academicProjectClass') {
        let query = this.form1.query;
        if (dsf.type(query) == "string") {
          query = JSON.parse(query);
        }
        query.searchValue = this.serchValue;
        this.form1.query = JSON.stringify(query);
      } else if (this.active == 'inTheCourse') {
        let query = this.form2.query;
        if (dsf.type(query) == "string") {
          query = JSON.parse(query);
        }
        query.searchValue = this.serchValue;
        this.form2.query = JSON.stringify(query);
      }
      if (this.isfirst) {
        this.isfirst = false;
      } else {
        this.reset();
      }
    },
    onSelect1(item) {
      if (this.active == 'academicProjectClass') {
        this.show1 = false;
        this.parms1.choose1 = item.name;

        let query = this.form1.query;
        if (dsf.type(query) == "string") {
          query = JSON.parse(query);
        }
        if (item.value == "") {
          delete query.sfwc_value;
        } else {
          query.sfwc_value = [item.value];
        }
        this.form1.query = JSON.stringify(query);
        this.reset();
      } else if (this.active == 'inTheCourse') {
        this.show1 = false;
        this.parms2.choose1 = item.name;

        let query = this.form2.query;
        if (dsf.type(query) == "string") {
          query = JSON.parse(query);
        }
        if (item.value == "") {
          delete query.sfwc;
        } else {
          query.sfwc = [item.value];
        }
        this.form2.query = JSON.stringify(query);
        this.reset();
      }
    },
    onSelect2(item) {
      if (this.active == 'academicProjectClass') {
        this.show2 = false;
        this.parms1.choose2 = item.name;

        let query = this.form1.query;
        if (dsf.type(query) == "string") {
          query = JSON.parse(query);
        }
        if (item.value == "") {
          delete query.sfbx;
        } else {
          query.sfbx = [item.value];
        }
        this.form1.query = JSON.stringify(query);
        this.reset();
      } else if (this.active == 'inTheCourse') {
        this.show2 = false;
        this.parms2.choose2 = item.name;

        let query = this.form2.query;
        if (dsf.type(query) == "string") {
          query = JSON.parse(query);
        }
        if (item.value == "") {
          delete query.sfbx;
        } else {
          query.sfbx = [item.value];
        }
        this.form2.query = JSON.stringify(query);
        this.reset();
      }
    },
    onScreen1(who) {
      let _this = this;
      if (_this[who] == "desc") {
        _this[who] = "asc";
      } else {
        _this[who] = "desc";
      }
      this.istime1 = this.istime1 == true ? false : true;
      this.queryOrder();
    },
    onScreen2(who) {
      let _this = this;
      if (_this[who] == "desc") {
        _this[who] = "asc";
      } else {
        _this[who] = "desc";
      }
      this.istime2 = this.istime2 == true ? false : true;
      this.queryOrder();
    },
    queryOrder() {
      if (this.active == 'academicProjectClass') {
        this.form1.order = JSON.stringify([
          {
            code: "xxsj",
            sort: this.xxsj1,
          },
        ]);
      } else if (this.active == 'inTheCourse') {
        this.form2.order = JSON.stringify([
          {
            code: "xxsj",
            sort: this.xxsj2,
          },
        ]);
      }
      this.reset();
    },


    getTabData() {
      const loading = dsf.layer.loading();
      this.$http
        .get(this.sourcesUrl)
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            this.tabs = res.data;
            this.active = this.tabs[0]['code'];
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
  }
});
</script>
